import { render } from "./MetasResult.vue?vue&type=template&id=0b0d441d&scoped=true"
import script from "./MetasResult.vue?vue&type=script&lang=js"
export * from "./MetasResult.vue?vue&type=script&lang=js"

import "./MetasResult.vue?vue&type=style&index=0&id=0b0d441d&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0d441d"]])

export default __exports__